import type { LocalNotification } from "@/Modules/BrowserNotifications/interfaces";

import useBrowserNotificationStore, {
  type BrowserNotificationStore,
} from "@/Modules/BrowserNotifications/Store";
import usePushNotificationsStore, { type PushNotificationStore } from "@/Modules/PushNotifications/Store";
import { danger } from "@/Utils/Debug";

import { isApp } from "@/Utils/Ionic";

class NotifcateActionHandler {
  constructor(
    private readonly browserNotificationStore: BrowserNotificationStore = useBrowserNotificationStore(),
    private readonly pushNotificationStore: PushNotificationStore = usePushNotificationsStore()
  ) {}

  public async handle(notification: LocalNotification): Promise<void> {
    try {
      if (isApp()) {
        this.pushNotificationStore.showNotification({ title: notification.title, body: notification.body });
      } else {
        this.browserNotificationStore.notify(notification).catch((e) => {
          danger("Error browser notification", e);
        });
      }
    } catch (e) {
      danger("Error notificate", e);
    }
  }
}

export default NotifcateActionHandler;
